import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ArrowRight, MessageCircle } from "lucide-react";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="bg-white pb-16 sm:pb-24 lg:pb-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-navy px-6 py-16 text-center sm:px-12 lg:py-24">
          <div className="grain-overlay pointer-events-none absolute inset-0" />
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-ocean-600/25 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-ember/20 blur-3xl" />

          <div className="relative">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-ocean-500">
              <MessageCircle className="h-3.5 w-3.5" />
              Respuesta directa por WhatsApp
            </span>
            <h2 className="mx-auto mt-6 max-w-3xl font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl text-balance">
              ¿Listo para climatizar su hogar o negocio con garantías reales?
            </h2>
            <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-300">
              Obtenga su presupuesto personalizado en menos de 2 minutos. Sin compromiso,
              sin llamadas insistentes: solo una propuesta seria y detallada.
            </p>
            <Link
              to="/presupuesto"
              data-testid="final-cta-budget-btn"
              className="group mt-9 inline-flex items-center gap-2.5 rounded-full bg-ember px-8 py-4 text-sm font-semibold text-white shadow-xl shadow-ember/25 transition-all duration-300 hover:-translate-y-0.5 hover:bg-ember-700"
            >
              Crear mi presupuesto
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
